export default {
  delayBeforeNavigate: 800,
  stateChangeOverlayModalDuration: 2500,
  messageLoopDelay: 100,
  messagePlaceholderDelay: 1500
}
